import { PAGE_TITLE_SEPARATOR, PAGE_TITLE_SUFFIX, PAGE_TITLE_B2B_SUFFIX } from '../constants';

export default function getPageTitle(title, isBusiness = false) {
  const suffix = isBusiness ? PAGE_TITLE_B2B_SUFFIX : PAGE_TITLE_SUFFIX;

  if (!title) {
    return suffix;
  }

  const filteredTitle = title.replace(/<\/?.*?>/g, '');

  return `${filteredTitle}${PAGE_TITLE_SEPARATOR}${suffix}`;
}
